module.exports = __webpack_public_path__ + "static/img/ivo.d76f815.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posters/ivo.png
// module id = Fh/r
// module chunks = 1